import React, {Fragment} from 'react';
import './Footer.css';
import {Link} from 'react-router-dom';

const Footer = () =>{
    return(
        <Fragment>
            <div className="content-footer">
                <Link to="/"> &copy; Derechos reservados - El Pollo Rico </Link>
            </div>
        </Fragment>
    );  
}

export default Footer;